import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../../../shared";
import {
	wsGroupActionAdvancedIncidentAddUpdateParm,
	wsGroupActionAdvancedIncidentCalendarDataParm,
	wsGroupActionAdvancedIncidentDataParm,
	wsGroupActionAdvancedIncidentPenaltyRefreshParm,
} from "./GroupActionAdvanced";
import { wsGroupActionBasicIncidentDataParm, wsGroupActionBasicIncidentCalendarDataParm, wsGroupActionBasicIncidentAddUpdateParm } from "./GroupActionBasic";
import { GroupActionNewReminderRequest } from "./group-action-new-reminder-request";
import { GroupActionReminderUpdateRequest } from "./group-action-reminder-update-request";
import { GroupActionPortalNotificationRequest } from "./GroupActionPortalNotificationRequest";

@Injectable({
	providedIn: "root",
})
export class GroupActionService {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------
	//	BASIC MODE SECTION
	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------

	//-----------------------------------------------------------------------------------------------------
	//
	//	GroupActionBasicIncidentGetData
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionBasicIncidentGetData(parms: wsGroupActionBasicIncidentDataParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionBasicIncidentGetData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GroupActionBasicIncidentGetCalendarData
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionBasicIncidentGetCalendarData(parms: wsGroupActionBasicIncidentCalendarDataParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionBasicIncidentGetCalendarData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GroupActionBasicIncidentAdd
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionBasicIncidentAdd(parms: wsGroupActionBasicIncidentAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionBasicIncidentAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionBasicIncidentUpdate(parms: wsGroupActionBasicIncidentAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionBasicIncidentUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------

	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------
	//	ADVANCED MODE SECTION
	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentGetStudentData
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionAdvancedIncidentGetData(parms: wsGroupActionAdvancedIncidentDataParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionAdvancedIncidentGetData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentGetCalendarData
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionAdvancedIncidentGetCalendarData(parms: wsGroupActionAdvancedIncidentCalendarDataParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionAdvancedIncidentGetCalendarData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentRefreshPenalty
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionAdvancedIncidentRefreshPenalty(parms: wsGroupActionAdvancedIncidentPenaltyRefreshParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionAdvancedIncidentRefreshPenalty";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentAdd
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionAdvancedIncidentAdd(parms: wsGroupActionAdvancedIncidentAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionAdvancedIncidentAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	GroupActionAdvancedIncidentUpdate(parms: wsGroupActionAdvancedIncidentAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionAdvancedIncidentUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionAdvanceModeEnabled() {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionAdvanceModeEnabled?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------
	//	REMINDER SECTION
	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------

	GroupActionExistingReminderSelectList(SchoolID, GroupID) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionExistingReminderSelectList?SchoolID=" + SchoolID + "&GroupID=" + GroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionExistingReminderInsert(GroupID, StationReminderAlertID, AddStudentPrompt) {
		var postResult$ = new Subject();
		var url =
			"Groups/GroupActionExistingReminderInsert?GroupID=" +
			GroupID +
			"&StationReminderAlertID=" +
			StationReminderAlertID +
			"&AddStudentPrompt=" +
			AddStudentPrompt;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	LoadSoundPopupList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LoadSoundPopupList?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionNewReminderInsert(parms: GroupActionNewReminderRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionNewReminderInsert?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GroupActionReminderSelect(GroupActionID) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionReminderSelect?GroupActionID=" + GroupActionID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupActionReminderUpdate(parms: GroupActionReminderUpdateRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionReminderUpdate?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------

	GroupActionPortalNotificationSend(parms: GroupActionPortalNotificationRequest) {
		var postResult$ = new Subject();
		var url = "Groups/GroupActionPortalNotificationSend?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
